module.exports = __webpack_public_path__ + "img/01.9e08e9c3.jpg";